class CustomerService {
  constructor(params) {
    this.serviceId = params.serviceId || '';
    this.cardId = params.cardId || '';
  }
}

export { CustomerService };



// WEBPACK FOOTER //
// ./src/models/CustomerService.js